import React, { useState, useEffect } from 'react'
import NavbarUser from '../../components/navbar/NavbarUser'
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../components/datatable/AppDataGrid';
// import { columns } from './component/viewflowprocess/columnOnprocess';
import { columns } from './component/journalhistory/columnJournalhistory';
import FetchApi from '../customhooks/Functionapi';
import { useDemoData } from '@mui/x-data-grid-generator';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import PageHeader from '../../components/pageheader/PageHeader';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';

import {
    useParams
} from "react-router-dom";


function ViewOnProcess() {
    const { data, loading } = useDemoData({
        dataSet: 'Commodity',
        rowLength: 10,
        maxColumns: 6,
    });

    const FetchApis = new FetchApi();
    const [datalist, setDatalist] = useState([])
    const [textSearch, setTextSearch] = useState([])

    useEffect(() => {
        jouranlall()
    }, [])

    async function jouranlall() {

        await FetchApis.FethcGet(`/document/JournalNotSuccessfullylist`).then(res => {

            if (res.status == 200) {
                setDatalist(res.data)
                setTextSearch(res.data)
            }

        })
    }














    function getRowId(row) {
        return row.JournalID;
    }

    function getSearchJournal(ev) {
        console.log(ev)
        const filteredData = textSearch.filter(item => {
            return Object.values(item)
                .join('')
                .toLowerCase()
                .includes(ev.toLowerCase());
        });

        setDatalist(filteredData);
    }

    return (
        <div>
            <NavbarUser />
            <div style={{ padding: 10 }}>
                <PageHeader
                    title="Document List All"
                    subtitle="Manage document On Process"
                    icon={HourglassTopRoundedIcon}
                    color="#ef6c00"
                    count={datalist.length}
                    onSearch={(e) => getSearchJournal(e.target.value)}
                    searchPlaceholder="Search"
                />
                <div>
                    <AppDataGrid
                        rows={datalist}
                        getRowId={getRowId}
                        columns={columns}
                        loading={loading}
                        slots={{ toolbar: GridToolbar }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50, 100]}
                    />
                </div>
            </div>
        </div>
    )
}

export default ViewOnProcess